import { Component, OnInit, ViewChild } from '@angular/core';
import { TutorialesService } from './tutoriales.service';
import { TutorialesEntry } from 'src/app/shared/entrys/tutoriales.entry';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
	selector: 'app-tutoriales',
	templateUrl: './tutoriales.component.html',
	styleUrls: ['./tutoriales.component.scss']
})
export class TutorialesComponent implements OnInit {
	tutoriales: Array<TutorialesEntry>;
	selectData: TutorialesEntry;
	formSearch: FormGroup;
@ViewChild ('videoPlay', { static: false })
videoPlayer: any;

	constructor(private tutorialesService: TutorialesService, private formBuilder: FormBuilder) {
		this.selectData = {} as TutorialesEntry;
	}

	ngOnInit() {
		this.tutorialesService.get(null).subscribe(resultado => {
			if (resultado.result) {
				this.selectData = resultado.data[0] as TutorialesEntry;
				this.tutoriales = resultado.data as Array<TutorialesEntry>;
			}
		});

		this.formSearch = this.formBuilder.group({
			search: ['']
		});
	}

	selectRow(row: TutorialesEntry) {
		this.videoPlayer.nativeElement.pause();
		this.selectData = row;
		this.videoPlayer.nativeElement.load();
		this.videoPlayer.nativeElement.play();

	}
}
